module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5LunH"))).then(() => module.bundle.root('iDabs'));